import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function MunicipalityContent({
  selectedMunicipality,
  showMunicipalitySelected,
  municipalityInfo,
  clearTransaction,
  history,
}) {
  const [selected, setSelected] = useState();

  const updateData = () => {
    if (typeof selected !== 'undefined') {
      showMunicipalitySelected(selectedMunicipality);
    }
    if (typeof selected === 'undefined') {
      history.push('/general-settings/address/municipality');
    }
    // history.push(`${match.url}/${selectedMunicipality}`);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedMunicipality)) {
      updateData();
      setSelected(selectedMunicipality);
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedMunicipality)) {
      updateData();
      setSelected(selectedMunicipality);
    }
  }, [selectedMunicipality]);
  return (
    <div className="container-fluid card-section-content">
      <div className="card-body">
        {/* <div className="row pt-4 pb-2 bg-white">
        <div className="col-12 d-flex">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
          >
            Add Province <i className="fas fa-plus" />
          </button>
        </div>
      </div> */}
        {!_.isEmpty(municipalityInfo) ? (
          <React.Fragment>
            <div className="row bg-white pb-3 pt-4">
              <div className="col-10">
                <h2 className="">
                  {_.get(municipalityInfo, 'attributes.name')}
                </h2>
                <span className="label-secondary">
                  {_.get(municipalityInfo, 'attributes.description')}
                </span>
              </div>
              {/* <div className="col-2 d-flex">
              <div className="py-3 ml-auto">
                <button
                  type="button"
                  className="btn-blank"
                  onClick={handleEdit(municipalityInfo)}
                >
                  <i className="far fa-edit icon-edit" />
                </button>
                <button
                  type="button"
                  className="btn-blank"
                  onClick={handleRemove(municipalityInfo)}
                >
                  <i className="far fa-trash-alt icon-delete" />
                </button>
              </div>
            </div> */}
            </div>
            <div className="row">
              <div className="col-12">
                <div className="right-section-content py-4 my-3">
                  <div className="d-flex flex-row align-items-center mb-3">
                    <div className="px-3">
                      <h3 className="m-0">Details</h3>
                    </div>
                    <div className="px-3 ml-auto">
                      {/* <button
                  type="button"
                  className="btn btn-secondary btn-round font-weight-bold px-4 ml-auto"
                  onClick={handleAddNatureBusinessModal(selectedMunicipality)}
                >
                  Add Province <i className="fas fa-plus" />
                </button> */}
                    </div>
                  </div>
                  <div className="d-flex flex-row">
                    <div className="table-container w-100 mx-3">
                      <table className="w-100">
                        <thead>
                          <tr>
                            <td className="pl-4">Code</td>
                            <td>Name</td>
                            <td className="pr-4" />
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="td-item pl-4">
                              {_.get(municipalityInfo, 'attributes.code') || '--'}
                            </td>
                            <td className="td-item">
                              {_.get(municipalityInfo, 'attributes.name') || '--'}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

MunicipalityContent.defaultProps = {
  selectedMunicipality: '',
}

MunicipalityContent.propTypes = {
  showMunicipalitySelected: PropTypes.instanceOf(Function).isRequired,
  municipalityInfo: PropTypes.instanceOf(Object).isRequired,
  selectedMunicipality: PropTypes.string,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  municipalityInfo: _.get(api, `${c.GET_MUNICIPALITY_SELECTED}.item`) || {},
  selectedMunicipality: _.get(match, 'params.municipalityId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MunicipalityContent);
